
import * as React from "react";
import { useState } from "react";
import { ITeamRegForm } from "../../../types/auth";
import CommunityScreen from './Community'
import ChannelScreen from "./Channels";
import { useHistory, useLocation } from "react-router";
import { joinChannel } from "../../../redux/actions/programAction";
import { useDispatch } from "react-redux";

interface PropsType {
  authError: string;
  userStatus: boolean;
  createTeam: (data: ITeamRegForm) => any;
}

function OnBoardingScreen(props: PropsType) {
  const location = useLocation(), history = useHistory(),dispatch = useDispatch() 
  const searchParams = new URLSearchParams(location.search);
  const [phase, setPhase]=useState(1)
  const communityIdentifier = searchParams.get("community");
  const activeProgramEnrollment = JSON.parse(localStorage.getItem('activeProgramEnrollment') || '{}')
  const registeredCommunity = activeProgramEnrollment?.communityIdentifier
  const [selectedCommunity, setSelectedCommunity] = useState<string | null>(null);
  const handleCommunityNextPhase = () => {
    setPhase(2); 
  };
  const handleChannelBack = () => {
    if (communityIdentifier) {
      history.push('/user/dashboard')
    }
    setPhase(1);
  };

  React.useEffect(() => {
    if (registeredCommunity) {
      setSelectedCommunity(registeredCommunity)
      setPhase(2)
    } else if (communityIdentifier) {
      setSelectedCommunity(communityIdentifier)
      setPhase(2);
    }
  }, [location]);


  return (
    <>
      {phase === 1 ? (
        <CommunityScreen 
          handleNextPhase={handleCommunityNextPhase} 
          setSelectedCommunity={setSelectedCommunity} 
          selectedCommunity={selectedCommunity}
        />
      ) : (
        <ChannelScreen 
          handleBackPhase={handleChannelBack} 
          selectedCommunity={selectedCommunity} 
        />
      )}
    </>
  );
}

export default OnBoardingScreen;


